// import Link from 'next/link'
import { ComponentType } from 'react'
import { Clock, Circle, User, Users, Info, Hash, FileText } from 'react-feather'
import { Game } from 'types'
import { formattedDateTimeFull } from 'shared/timeHelper'
import {
  fieldPath,
  gamePath,
  gamePresstextPath,
  scheduleSearchPath,
  tournamentSchedulePath
} from 'shared/urlHelpers'
import { getExtraStateNames } from 'data/helpers'
import Link from 'next/link'
import LinkButton from '@/components/router/LinkButton'
import CalendarImport from '../layout/CalendarImport'
import OrtungHalleIcon from 'public/img/ci-icons/ortung-halle.svg'
// import CalendarImport from '@/components/layout/CalendarImport'
import LivePlayIcon from 'public/img/ci-icons/live-play.svg'

export const ListItemDetail: ComponentType<{
  game: Game
  className?: string
}> = ({ game, className }) => {
  return (
    <>
      <div className="grid @xl/schedule:grid-cols-2 px-4">
        <div className="py-3 @xl/schedule:pl-3">
          <div className="text-sm text-muted flex items-baseline gap-1">
            <Clock className="w-4 h-4 relative top-0.5 inline-block" />
            Spielbeginn
          </div>
          <div className="">
            <Link href={gamePath(game)}>
              {formattedDateTimeFull(game.startsAt)}
            </Link>
          </div>

          {game.field && (
            <>
              <div className="text-sm mt-2 text-muted flex items-baseline gap-1">
                <OrtungHalleIcon className="w-4 h-4 relative top-0.5 inline-block" />
                Halle
              </div>
              <div className="">
                {game.field && (
                  <Link href={fieldPath(game.field)}>
                    {game.field.name}, {game.field.city}{' '}
                    {/* <ChevronRight className="w-4 h-4 inline-block -mt-px" /> */}
                    {game.field.fieldNumber && (
                      <small>({game.field.fieldNumber})</small>
                    )}
                  </Link>
                )}
              </div>
            </>
          )}

          <div className="text-sm mt-2 text-muted flex items-baseline gap-1">
            <Circle className="w-4 h-4 relative top-0.5 inline-block" />
            Staffel / Runde
          </div>
          <div className="">
            <Link
              href={
                tournamentSchedulePath(game.tournament) +
                `?phase=${game.phase.id}`
              }
            >
              {game.phase.name}
            </Link>{' '}
            /{' '}
            <Link
              href={
                tournamentSchedulePath(game.tournament) +
                `?phase=${game.phase.id}&round=${game.round.id}`
              }
            >
              {game.round.name}
            </Link>
          </div>

          {game.refereeInfo && (
            <>
              <div className="text-sm mt-2 text-muted flex items-baseline gap-1">
                <User className="w-4 h-4 relative top-0.5 inline-block" />
                Schiedsrichter
              </div>
              <div className="">
                <Link href={gamePath(game)}>{game.refereeInfo}</Link>
              </div>
            </>
          )}

          {game.attendance && game.attendance > 0 && (
            <>
              <div className="text-sm mt-2 text-muted flex items-baseline gap-1">
                <Users className="w-4 h-4 relative top-0.5 inline-block" />
                Zuschauer
              </div>
              <div className="">
                <Link href={gamePath(game)}>{game.attendance}</Link>
              </div>
            </>
          )}

          {game.extraStates && game.extraStates.length > 0 && (
            <>
              <div className="text-sm mt-2 text-muted flex items-baseline gap-1">
                <Info className="w-4 h-4 relative top-0.5 inline-block" />
                Hinweis
              </div>
              <div className="">
                <Link href={gamePath(game)}>{getExtraStateNames(game)}</Link>
              </div>
            </>
          )}

          {game.gameNumber && (
            <>
              <div className="text-sm mt-2 text-muted flex items-baseline gap-1">
                <Hash className="w-4 h-4 relative top-0.5 inline-block" />
                Spielnummer
              </div>
              <span title={'Spielnummer ' + game.gameNumber}>
                {game.gameNumber}
              </span>
            </>
          )}

          {game.updatedAt && (
            <div>
              <span
                className="text-xs mt-2 text-muted flex items-baseline gap-1"
                title={game.meta}
              >
                letztes Update: {formattedDateTimeFull(game.updatedAt)} Uhr
              </span>
            </div>
          )}
        </div>

        <div className="divide-y divide-gray-200 mt-4 border-t border-gray-200 @xl/schedule:pl-10 @xl/schedule:border-t-transparent @xl/schedule:mt-0">
          <div>
            {/* TODO: Timo: can you please check why the overlay does only overlap the search table and not the whole screen? */}
            <CalendarImport
              option={{ id: game.id, title: 'Spiel', type: 'game' }}
              size="l"
              inlineOverlay={true}
              currentPath={scheduleSearchPath()}
            />
            {/* <LinkButton
              className="w-full block"
              buttonClassName="btn-short !pl-0 !m-0 !py-3 w-full @xl/schedule:justify-start"
              color="link"
              href={gameCalenderPath(game.id, 'apple')}
            >
              <KalenderIcon className="ci-icon" />
              <span>Kalender abonnieren</span>
            </LinkButton> */}
          </div>
          {game.livestreamUrl && (
            <LinkButton
              className="w-full block"
              buttonClassName="btn-short !pl-0 !m-0 !py-3 w-full @xl/schedule:justify-start"
              color="link"
              href={game.livestreamUrl}
              openInNewWindow={true}
              tooltip="zum Livestream"
              ariaLabel="zum Livestream"
            >
              <LivePlayIcon width={24} height={24} className="ci-icon" />
              <span>Livestream</span>
            </LinkButton>
          )}
          {game.showPresstext && (
            <div>
              <LinkButton
                className="w-full block"
                buttonClassName="btn-short !pl-0 !m-0 !py-3 w-full md:justify-start"
                color="link"
                href={gamePresstextPath(game)}
              >
                <FileText className="ci-icon" />
                <span>Spielbericht</span>
              </LinkButton>
            </div>
          )}
          {/* <div>
            <LinkButton
              className="w-full block"
              buttonClassName="btn-short !pl-0 !m-0 !py-3 w-full @xl/schedule:justify-start"
              color="link"
              href={gamePath(game)}
            >
              <Star className="ci-icon" />
              <span>Favorit hinzufügen</span>
            </LinkButton>
          </div> */}
          {/* <div>
            <LinkButton
              className="w-full block"
              buttonClassName="btn-short !pl-0 !m-0 !py-3 w-full @xl/schedule:justify-start"
              color="link"
              href={gamePath(game)}
            >
              <PushIcon className="ci-icon" />
              <span>Push Notifications</span>
            </LinkButton>
          </div> */}
        </div>
      </div>
    </>
  )
}
